var _metadata, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg34Empty({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1024.000000pt",
    height: "1024.000000pt",
    viewBox: "0 0 1024.000000 1024.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by potrace 1.16, written by Peter Selinger 2001-2019\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,1024.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2248 9033 c-17 -4 -18 -199 -18 -3919 l0 -3914 2890 0 2890 0 0 3920 0 3920 -2872 -1 c-1580 -1 -2881 -3 -2890 -6z m5347 -3913 l0 -3495 -2475 0 -2475 0 -3 3485 c-1 1917 0 3490 2 3497 4 10 552 12 2478 10 l2473 -2 0 -3495z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg34Empty);
export default __webpack_public_path__ + "static/media/3_4_empty.30468a58a99d896558226d1bd3e73f32.svg";
export { ForwardRef as ReactComponent };